export default class Functions {
    constructor(adapter) {
        this.client = adapter.getPlatformClient()
    }

    async run(id, input, query) {
        const { data } = await this.client.post(`/v1/system/function/run/${id}`, input, {
            params: query || {},
        })

        return data.data
    }

    async generateSignature(ref, env) {
        const { data } = await this.client.get(`/v1/system/function/signature/${env}/${ref}`)

        return data.signature
    }
}